import React from 'react';
import Image from 'next/image';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';

import { formatLargeNumber, hasFollowers } from 'utils/helpers';
import { openModal } from 'features/utilsSlice';
import useProfileOwner from 'hooks/useProfileOwner';
import useIsLoggedIn from 'hooks/useIsLoggedIn';
import styles from 'styles/components/profile/Profile.module.scss';

const marginTop = { marginTop: 5 };

const InfluencerNetworks = ({ influencerNetworks = [], profile, profilePreview, isDialog }) => {
  const profileOwner = useProfileOwner(profile);
  const dispatch = useDispatch();
  const isLoggedIn = useIsLoggedIn();

  const filteredInfluencerNetworks = influencerNetworks.filter(
    influencerNetwork =>
      influencerNetwork.network.name !== 'Image & Likeness' &&
      influencerNetwork.profile_screenshot_status === 'verified'
  );

  // Special styling for Fansly icon because of its size
  const getFanslyMargin = networkName => {
    if (networkName !== 'Fansly') return {};

    return { marginTop: '-10px' };
  };

  if (filteredInfluencerNetworks.length === 0) return null;

  return (
    <div
      className={clsx(styles.networks, {
        [styles.dialogBackground]: isDialog,
        [styles.networkBackground]: profileOwner && !profilePreview && !isDialog,
        [styles.whiteBackground]: !isLoggedIn,
      })}
    >
      <div
        className={clsx(
          { [styles.bioBorder]: profileOwner && !profilePreview },
          styles.networksContent
        )}
        onClick={() => {
          if (!profilePreview) {
            return dispatch(openModal({ name: 'Inventory Edit', data: { step: 'Networks' } }));
          }
        }}
      >
        {filteredInfluencerNetworks
          .sort((a, b) => b.active - a.active)
          .map((influencerNetwork, index) => {
            const { network, top_creator_percentage, max_followers } = influencerNetwork;
            const networkName = network.name;
            const isFansly = networkName === 'Fansly';

            return (
              <div key={influencerNetwork.id} style={marginTop}>
                {profileOwner ? (
                  <div
                    className={clsx(styles.network, {
                      [styles.removeMargin]: index + 1 === filteredInfluencerNetworks.length,
                      [styles.fanslyIcon]: isFansly, // Apply special styling for Fansly icon because of its size
                    })}
                  >
                    <div style={{ position: 'relative' }}>
                      <Image
                        src={`/icons/network/white/${networkName
                          .replace(/\s/g, '')
                          .replace(/[&,\/]/, '_')
                          .toLowerCase()}.svg`}
                        width={21}
                        height={21}
                        alt={networkName}
                        unoptimized
                      />
                    </div>

                    {hasFollowers(influencerNetwork) && (
                      <div style={{ position: 'relative' }}>
                        <h6 style={getFanslyMargin(networkName)}>
                          {formatLargeNumber(max_followers)}
                        </h6>

                        {top_creator_percentage > 0 && (
                          <h6 className="color-main" style={getFanslyMargin(networkName)}>
                            Top {top_creator_percentage}%
                          </h6>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <a
                    onClick={e => e.stopPropagation()}
                    href={influencerNetwork.social_profile_url}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <div
                      className={clsx(styles.network, {
                        [styles.removeMargin]: index + 1 === filteredInfluencerNetworks.length,
                        [styles.fanslyIcon]: isFansly, // Apply special styling for Fansly icon because of its size
                      })}
                    >
                      <div style={{ position: 'relative' }}>
                        <Image
                          src={`/icons/network/white/${networkName
                            .replace(/\s/g, '')
                            .replace(/[&,\/]/, '_')
                            .toLowerCase()}.svg`}
                          width={21}
                          height={21}
                          alt={networkName}
                          unoptimized
                        />
                      </div>

                      {hasFollowers(influencerNetwork) && (
                        <div style={{ position: 'relative' }}>
                          <h6 style={getFanslyMargin(networkName)}>
                            {formatLargeNumber(max_followers)}
                          </h6>

                          {top_creator_percentage > 0 && (
                            <h6 style={getFanslyMargin(networkName)} className="color-main">
                              Top {top_creator_percentage}%
                            </h6>
                          )}
                        </div>
                      )}
                    </div>
                  </a>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default InfluencerNetworks;
